import { AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { select, Store } from '@ngrx/store';
import { CompanySubset } from 'app/api/company.api.service';
import { CompaniesSelectors } from '../company/selectors';
import { AppState } from 'app/reducers';
import { AmplifyService } from 'aws-amplify-angular';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter, map, switchMap, tap, startWith } from 'rxjs/operators';
import { selectCubeLoading } from 'app/main/cube/cube.selectors';

@Component({
    selector: 'charts',
    templateUrl: './charts.component.html',
    styleUrls: ['./charts.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class ChartsComponent implements OnInit, OnDestroy, AfterViewInit {
    public pageTitle$: Observable<string>;
    public company$: Observable<CompanySubset>;
    public loading$: Observable<boolean>;

    // Protected
    protected logger: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        protected amplifyService: AmplifyService,
        protected router: Router,
        protected activatedRoute: ActivatedRoute,
        protected store: Store<AppState>
    ) {
        this.logger = this.amplifyService.logger('ChartsComponent');
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.loading$ = this.store.pipe(select(selectCubeLoading));

        this.company$ = this.store
            .pipe(
                takeUntil(this._unsubscribeAll),
                select(CompaniesSelectors.selectCurrentCompany),
            ); 
            
        this.pageTitle$ = this.router.events
            .pipe(
                startWith(new NavigationEnd(0, '/', '/')), // required to catch first run
                filter(event => event instanceof NavigationEnd),
                map(() => this.activatedRoute),
                map(route => route.firstChild),
                switchMap(route => route.data),
                map(data => data['title'])
            );
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
